import { memo, useMemo } from "react";

import { calculatePriceChange } from "./type";
import { StockResult } from "@/src/hooks/useStockDashboard";
import { useStockField } from "@/src/hooks";

interface StockPriceChangeProps {
  /** 股票数据 */
  stock: StockResult;
}

const StockPriceChangeOrg = ({ stock }: StockPriceChangeProps) => {
  const stockData = useStockField(
    stock?.symbol,
    "p",
    stock?.trading_data?.current_price,
  );

  // 使用 useMemo 缓存所有计算结果
  const { textColorClass, displayText } = useMemo(() => {
    if (!stockData?.value || !stock?.trading_data?.previous_close) {
      return {
        textColorClass: "text-content_secondary",
        displayText: "--",
      };
    }
    const currentPrice = Number(stockData?.value || 0);
    const previousClose = Number(stock?.trading_data?.previous_close || 0);
    const change = currentPrice - previousClose;

    const calculatedResult = calculatePriceChange(currentPrice, previousClose);

    // 确定样式类名
    let colorClass: string;
    if (change > 0) {
      colorClass = "text-content_accent1_primary";
    } else if (change < 0) {
      colorClass = "text-content_accent2_primary";
    } else {
      colorClass = "text-content_secondary";
    }

    return {
      textColorClass: colorClass,
      displayText: calculatedResult,
    };
  }, [stockData?.value, stock?.trading_data?.previous_close]);

  return (
    <div className="flex items-center flex-row">
      <span className={`body_bold_m ${textColorClass}`}>{displayText}</span>
    </div>
  );
};

export const StockPriceChange = memo(StockPriceChangeOrg);
